import React, {Fragment} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import { throwException } from "../../actions/exceptionActions";
import redirector from "../../util/redirector";

import AdresWizardHelper from "./adresWizardHelper";

import AutoBindComponent from "../common/AutoBindComponent";
import Row from "../common/Row";
import TextInput from "../common/TextInput";
import Button from "../common/Button";
import AdresModal from "./adresModal";
import Col from "../common/Col";
import ValidationGroup from "../common/ValidationGroup";

class AdresWizard extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

		this.state = {
			openModal: false,
			straten: [],
			huisnummers: [],
			busnummers: [],
			straatEnabled: false,
			huisnummerEnabled: false,
			busnummerEnabled: false,
			confirmDisabled: true,
			savedAdres: null,
			model: {
				id: null,
				displayName: "",
				gemeenteUUId: "",
				gemeenteId: 0,
				gemeenteKey: "",
				gemeenteNaam: "",
				postcode: "",
				straatId: 0,
				straatNaam: "",
				huisNummer: "",
				busNummer: "",
				huisnummerId: null,
				busnummerId: null,
				latitude: null,
				longitude: null
			},
			errors: []
		};

		this.state.errors = props.errors || [];

		this.state.savedAdres = props.model || {
			id: null,
			adresObjectId: null,
			displayName: "",
			gemeenteId: "",
			gemeenteNaam: "",
			postCode: "",
			straatId: 0,
			straatNaam: "",
			huisNummer: "",
			busNummer: "",
			latitude: null,
			longitude: null
		};

		this.helper = new AdresWizardHelper(this, redirector);
    }

	componentDidMount = () => {
		super.componentDidMount();
		this.helper.init();
	};

	handleOnGemeenteChange = (event) => this.helper.gemeenteChanged(event);
	handleOnStraatChange = (event) => this.helper.straatChanged(event);
	handleOnHuisnummerChange = (event) => this.helper.huisnummerChanged(event);
	handleOnBusnummerChange = (event) => this.helper.busnummerChanged(event);
	handleOnCloseAdresModal = (confirm) => this.helper.closeAdresModal(confirm);
	handleOnOpenModal = () => this.helper.openAdresModal();

	render(){
		const savedAdres = this.state.savedAdres;
		const selectedModel = this.state.model;
		const openModal = this.state.openModal;
		const gemeenten = this.props.gemeenten;
		const straten = this.state.straten;
		const huisnummers = this.state.huisnummers;
		const busnummers = this.state.busnummers;
		const straatEnabled = this.state.straatEnabled;
		const huisnummerEnabled = this.state.huisnummerEnabled;
		const busnummerEnabled = this.state.busnummerEnabled;
		const confirmDisabled = this.state.confirmDisabled;
		const errors = this.props.errors;

		return (
			<Fragment>
				{!openModal || <AdresModal
					confirmAdres={this.handleOnCloseAdresModal} {...this.props}
					adresModel={selectedModel}
					gemeenten={gemeenten}
					straten={straten}
					huisnummers={huisnummers}
					busnummers={busnummers}
					onGemeenteChange={this.handleOnGemeenteChange}
					onStraatChange={this.handleOnStraatChange}
					onHuisnummerChange={this.handleOnHuisnummerChange}
					onBusnummerChange={this.handleOnBusnummerChange}
					straatEnabled={straatEnabled}
					huisnummerEnabled={huisnummerEnabled}
					busnummerEnabled={busnummerEnabled}
					errors={errors}
					confirmDisabled={confirmDisabled}
				/>}
				<ValidationGroup messages={errors ? errors['adres'] : ""}>
					<Row>
						<TextInput
							disabled
							name="displayName"
							label="Gemeente - postcode"
							value={savedAdres.displayName}
							size={6}
							validationMessage={errors ? errors['gemeente'] : ""}
						/>
					</Row>
					<Row>
						<TextInput
							disabled
							name="straatNaam"
							label="Straat"
							value={savedAdres.straatNaam}
							size={6}
							validationMessage={errors ? errors['straatNaam'] : ""}
						/>
						<TextInput
							disabled
							name="huisNummer"
							label="Huisnummer"
							value={savedAdres.huisNummer}
							size={3}
							validationMessage={errors ? errors['huisnummer'] : ""}
						/>
						<TextInput
							disabled
							name="busNummer"
							label="Busnummer"
							value={savedAdres.busNummer}
							size={3}
							validationMessage={errors ? errors['busNummer'] : ""}
						/>
					</Row>
					<Row>
						<Col size={3}>
							<Button onClick={this.handleOnOpenModal} text={"Adres invoeren"} />
						</Col>
					</Row>
				</ValidationGroup>
			</Fragment>
		);
	}
}

AdresWizard.propTypes = {
	onSave: PropTypes.func,
	model: PropTypes.object,
	errors: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	return {
		gemeenten: state.adressen.gemeenten
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		ajaxActions: bindActionCreators(ajaxActions, dispatch),
		throwException: bindActionCreators(throwException, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AdresWizard);
